import { render } from "./ExtensionSection.vue?vue&type=template&id=fea6e07a&scoped=true"
import script from "./ExtensionSection.vue?vue&type=script&lang=js"
export * from "./ExtensionSection.vue?vue&type=script&lang=js"

import "./ExtensionSection.vue?vue&type=style&index=0&id=fea6e07a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea6e07a"]])

export default __exports__